import { Route } from "react-router";
import React from "react";
import { ProtectedRoute } from "./components";
import { permissionsSubscriptionsFull } from "@/utils";
import { FeaturesList } from "@/components";

export const subscriptionRoutes = (
  _parentPath: string,
): React.ReactElement[] => [
  // <Route
  //   key="subscriptions"
  //   path=""
  //   element={
  //     <ProtectedRoute
  //       element={
  //         <SubscriptionsList
  //           parentPath={parentPath}
  //           // showAdd
  //           // showEdit
  //           // showDelete
  //           showFeatures
  //         />
  //       }
  //       codes={permissionsSubscriptionsReadonly}
  //     />
  //   }
  // />,

  <Route
    key="features-key"
    path="features/:key"
    element={
      <ProtectedRoute
        element={<FeaturesList />}
        codes={permissionsSubscriptionsFull}
      />
    }
  />,
];
